import {buildPermissions} from '#services/permissions'

const stored = JSON.parse(localStorage.getItem('user'))
const initialState = stored
  ? {
      ...stored,
      isLoggingIn: false,
      isLoggedIn: false,
      permissions: buildPermissions({role: stored.role}),
    }
  : {}

export default function authentication(state = initialState) {
  return state
}
